<template>
  <div>
    <modal-container @close="closeCardModel" borderRadius="0px">
      <div 
        class="card-modal"
        :style="{
          maxWidth: maxWidth,
          minWidth: minWidth
        }"
      >
        <slot></slot>
      </div>
    </modal-container>
  </div>
</template>

<script>
import ModalContainer from "../modals/modal-container.vue";
export default {
  components: { ModalContainer },
  emits: ["close-card-model"],
  props: {
    color: {
      type: String,
      default: "grey",
    },
    maxWidth: {
      type: String,
    },
    minWidth: {
      type: String,
    },
  },
  methods: {
    closeCardModel() {
      this.$emit("close-card-model");
    },
  },
};
</script>

<style scoped>
.card-modal {
  width: 100%;
}
</style>